<script lang="ts">
  import { observe } from "$lib/actions/observe";
  import { sanitizeSvg } from "$lib/utils/sanitize";

  let {
    sectionLabel = "",
    headline = "",
    description = "",
    services = [] as Array<{
      icon: string;
      title: string;
      description: string;
      linkText?: string;
      linkHref?: string;
    }>
  } = $props();
</script>

<section>
  <div class="container">
    {#if sectionLabel}
      <div class="section-divider fade-up" use:observe>
        <span class="section-label">{sectionLabel}</span>
        <h2>{headline}</h2>
        {#if description}
          <p>{description}</p>
        {/if}
      </div>
    {/if}
    <div class="services-grid stagger" use:observe>
      {#each services as service}
        <div class="card">
          {#if service.icon}
            <div class="card-icon" aria-hidden="true" style="background:var(--accent-bg);color:var(--accent)">
              {@html sanitizeSvg(service.icon)}
            </div>
          {/if}
          <h3>{service.title}</h3>
          <p>{service.description}</p>
          {#if service.linkText}
            <a href={service.linkHref || "#"} class="btn btn-ghost mt-1" style="font-size:0.875rem">
              {service.linkText} <span class="accent">→</span>
            </a>
          {/if}
        </div>
      {/each}
    </div>
  </div>
</section>
